import React from 'react';

export default function SecurityPageShell({
  refreshing,
  error,
  actionMessage,
  onDismissAction,
  onRetry,
  children,
}) {
  return (
    <>
      {refreshing ? (
        <div className="vx-sec-banner vx-sec-banner--refresh" role="status" aria-live="polite">
          Refreshing security data…
        </div>
      ) : null}

      {error ? (
        <div className="vx-sec-banner vx-sec-banner--error">
          <span>{error}</span>
          <button type="button" className="btn" onClick={onRetry}>
            Retry
          </button>
        </div>
      ) : null}

      {actionMessage ? (
        <div
          className={`vx-sec-banner vx-sec-banner--${actionMessage.type}`}
          role="status"
          aria-live="polite"
        >
          <span>{actionMessage.text}</span>
          <button
            type="button"
            className="vx-sec-banner-dismiss"
            onClick={onDismissAction}
            aria-label="Dismiss message"
          >
            ×
          </button>
        </div>
      ) : null}

      {children}
    </>
  );
}
